export default "__VITE_ASSET__DqijfzTd__"